import React, { Component } from 'react';
import Import from './components/Definitions/ImportContainer';
import FileList from './components/FileList/FileListContainer';
import { getSurveyImportFileList } from '../../../services/apps/SurveyProjectService';
import { matchShape } from '../../../components/prop-types';

class SurveyProjectDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      importedFiles: [],
      fileListLoading: false,
    };

    this.refetchFileList = this.refetchFileList.bind(this);
  }

  componentDidMount() {
    this.fetchFileList();
  }

  refetchFileList() {
    this.fetchFileList();
  }

  async fetchFileList() {
    const { match } = this.props;
    const { surveyProjectId, aid } = match.params;
    try {
      this.setState({
        fileListLoading: true,
      });
      const importedFiles = await getSurveyImportFileList({
        id: surveyProjectId,
        accountId: aid,
      });
      this.setState({
        importedFiles,
        fileListLoading: false,
      });
    } catch (errors) {
      this.setState({
        fileListLoading: false,
      });
    }
  }

  render() {
    const { importedFiles, fileListLoading } = this.state;
    return (
      <div className="p-grid">
        <div className="p-col-12">
          <Import {...this.props} refetchFileList={this.refetchFileList} />
        </div>
        <div className="p-col-12">
          <FileList
            {...this.props}
            refetchFileList={this.refetchFileList}
            importedFiles={importedFiles}
            loading={fileListLoading}
          />
        </div>
      </div>
    );
  }
}

SurveyProjectDetail.propTypes = {
  match: matchShape.isRequired,
};

export default SurveyProjectDetail;
